<template>
    <v-dialog
        v-model="dialog"
        fullscreen
    >
        <v-card>
            <v-toolbar
                dark
                color="primary"
            >
                <v-toolbar-title>Create Saved Message</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn
                        dark
                        text
                        @click="onClickDiscardChanges"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                        dark
                        text
                        :disabled="!is_valid"
                        @click="onClickSave"
                    >
                        Save
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text>
                <v-container
                    v-if="saved_message != null"
                >
                    <v-text-field
                        label="Title"
                        v-model="title"
                        hint="Titles should be lowercase and use dashes instead of spaces. For example, welcome-message, daily-hours, and address-downtown"
                        autofocus
                        :rules="[rules.required, rules.no_spaces, rules.no_hash_tag]"
                        style="padding-bottom: 15px"
                        autocomplete="off"
                    />

                    <m-edit-message-patterns-compact
                        v-model="message_patterns"
                        context="saved-message"
                    />

                    <v-switch
                        label="Available to all team members"
                        v-model="available_to_all_team_members"
                        v-on:change="onSwitchAvailableToAllTeamMembers"
                    />

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                            text
                            @click="onClickDiscardChanges"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                            text
                            :disabled="!is_valid"
                            @click="onClickSave"
                        >
                            Save
                        </v-btn>
                    </v-card-actions>

                </v-container>
            </v-card-text>
        </v-card>

        <m-bulk-recipient-preview-message-dialog
            ref="preview-message-dialog"
            hint="This is how the message will read using your name and a sample customer (Jane Doe)."
        />

    </v-dialog>
</template>

<script>

const { v4: uuidv4 } = require('uuid');
const _ = require('lodash');

export default {

    data() {
        return {
            dialog: false,
            title: '',
            message_patterns: [],
            bulk_message_recipient: {},
            saved_message: {},
            available_to_all_team_members: false,
            shown_available_to_all_team_members_warning: false,

            rules: {
                required: (value) => { if ( value == null || value.trim().length == 0 ) return 'Required'; return true;  },
                no_spaces: (value) => { if ( value == null || value.includes(" ") ) return 'No spaces, use dashes'; return true;  },
                no_hash_tag: (value) => { if ( value == null || value.includes("#") ) return 'Hashtag character not allowed'; return true;  },
            },
        }
    },

    methods: {

        onSwitchAvailableToAllTeamMembers()
        {
            if ( this.available_to_all_team_members )
            {
                this.saved_message.limit_to_employee_id = null;
            }
            else
            {
                this.saved_message.limit_to_employee_id = this.$rc.$state.profile.employee_account.employee_id;
            }
        },

        showDialog(saved_message)
        {
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
            this.saved_message = saved_message;

            this.title = this.saved_message.title;
            this.message_patterns = _.cloneDeep(this.saved_message.message_patterns);

            if ( this.saved_message.limit_to_employee_id )
            {
                this.available_to_all_team_members = false;
            }
            else
            {
                this.available_to_all_team_members = true;
            }
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
            this.content = null;
            this.title = null;

            this.$emit('close-dialog');
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }

            // The dialog is showing...
            if ( this.is_valid )
            {
                // data is valid, so save
                this.save();
                this.dialog = false;
                next();

                this.$emit('close-dialog');

                return;
            }

            this.$rc.snackbar('You must either correct the errors or discard your changes.',3500);
            this.dialog = false;
            next(false);
        },

        onClickSave()
        {
            if ( !this.available_to_all_team_members )
            {
                this.doSave();
                return;
            }

            this.$rc.confirm(
                'Saved Message Available to All Team Members',
                'This saved message is available to all team members. You should review it carefully to make sure it makes sense for any team member to send.',
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'Save', 'value' : 'confirm' },
                ],
                (response) => {
                    if ( response != 'confirm' )
                    {
                        return;
                    }

                    this.doSave();
                }
            );
        },

        doSave()
        {
            this.save();
            this.closeDialog();  
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        save()
        {
            this.saved_message.title = this.title;
            this.saved_message.content = this.content;
            this.saved_message.message_patterns = this.message_patterns;
            this.content_without_variables = null; // legacy, removed
            this.saved_message.use_legacy_varaibles = false; // legacy, removed

        
            this.$emit('ok', this.saved_message);
        },
    },

    computed: {
        is_valid() {

            return this.saved_message != null
                && this.title != null && this.title != '';
        },
    },
}
</script>

<style lang="scss" scoped>
</style>